<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <TableLoading v-if="product.publicId === '0'"/>
    <div v-else class="card">
      <div class="card-body">
        <b-tabs pills justified content-class="p-3 text-muted mx-4">
          <b-tab class="border-0" :active="tabIndex === 'info'" @click="tabSelectFn('info')">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block my-2">Product Information</span>
            </template>
            <product-information :productInfo="product" @refetchProduct="refetchProduct"/>
          </b-tab>
          <b-tab :active="tabIndex === 'order'" @click="tabSelectFn('order')">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block my-2">Product Orders</span>
            </template>
            <div class="p-4">
              <data-table :columns="productOrderColumns" :rows="product.ordersPaginated.objects" :has-pagination="false" @onSearch="searchOrderFn">
                <template v-slot:actions="slotProps">
                  <b-button v-if="checkForPermission(view_single_order_permission)" variant="info" size="sm" class="py-1 text-white" @click="viewStatementInvoice(slotProps.row.publicId)">
                    View Invoice
                  </b-button>
                </template>
              </data-table>
              <b-pagination
                  v-model="ordersCurrentPage"
                  :total-rows="product.ordersPaginated.total"
                  :per-page="perPage"
                  size="lg"
                  align="center"
                  class="mt-3"
              />
            </div>
          </b-tab>
          <b-tab :active="tabIndex === 'shipment'" @click="tabSelectFn('shipment')">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block my-2">Product Shipments</span>
            </template>
            <div class="pt-4">
              <shipment-table :rows="product.shipmentsPaginated" :columns="shipmentColumns" :has-pagination="false" @onSearch="searchFn"/>
              <b-pagination
                  v-model="shipmentCurrentPage"
                  :total-rows="product.shipmentsPaginated.total"
                  :per-page="perPage"
                  size="lg"
                  align="center"
                  class="mt-3"
              />
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import {routeItems} from "@/router/endpoints";
import ShipmentTable from "@/components/shipment/shipment-table";
import ProductInformation from "@/components/products/product-information";
import DataTable from "@/components/data-table";
import {SINGLE_PRODUCT} from "@/gql/stock";
import TableLoading from "@/components/TableLoading";
import {permissions} from "@/router/permissions";

export default {
  page: {
    title: "Single Product",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, DataTable, ProductInformation, ShipmentTable, PageHeader, Layout},
  name: "single-product",
  data() {
    return {
      title: "Single Product",
      tabIndex: 'info',
      view_single_order_permission: permissions.view_single_order_permission,
      shipmentCurrentPage: 1,
      ordersCurrentPage: 1,
      shipmentSearchKeyword: '',
      orderSearchKeyword: '',
      perPage: 30,
      items: [
        {
          text: "Products",
          href: routeItems.products_route
        },
        {
          text: "Single Product",
          active: true
        }
      ],
      shipmentColumns: [
        {
          field: 'orderId',
          label: 'B/L #'
        },
        {
          field: 'createdAt',
          label: 'Date Added'
        },
        {
          field: 'expiryDate',
          label: 'Expiry Date'
        },
        {
          field: 'quantity',
          label: 'Qty'
        },
        {
          field: 'orderPrice',
          label: 'Purchase Price'
        },
        {
          field: 'initialStockQuantity',
          label: 'Initial Stock Qty'
        },
        {
          field: 'newStockQuantity',
          label: 'New Stock Qty'
        },
      ],
      productOrderColumns: [
        {
          field: 'invoiceId',
          label: 'Order'
        },
        {
          field: 'createdAt',
          label: 'Order Date'
        },
        {
          field: 'orderedBy',
          label: 'Ordered By'
        },
        {
          field: 'deliveryDate',
          label: 'Delivery Date'
        },
        {
          field: 'grossOrderTotal',
          label: 'Order Total'
        },
        {
          field: 'orderStatus',
          label: 'Order Status'
        },
        {
          field: 'actions',
          label: 'Actions'
        }
      ],
      product: {
        publicId: '0',
        thumbnail: "",
        description: "",
        officialProductName: "",
        productName: "",
        code: "",
        abbreviation: "",
        itfcode: "",
        jancode: "",
        expiryPeriod: "",
        m3: "",
        minimumOrderUnit: "",
        volume: "",
        qpoUnit: "",
        quantityPerCase: "",
        caseWeight: "",
        bowlWeight: "",
        unitWeight: "",
        shipmentsPaginated: {
          total: "",
          objects: []
        },
        ordersPaginated: {
          total: "",
          objects: []
        }
      }
    }
  },
  apollo: {
    product: {
      query: SINGLE_PRODUCT,
      variables(){
        return{
          id: this.$route.params.id,
          shipmentCurrentPage: this.shipmentCurrentPage,
          shipmentSearchKeyword: this.shipmentSearchKeyword,
          ordersCurrentPage: this.ordersCurrentPage,
          orderSearchKeyword: this.orderSearchKeyword
        }
      }
    }
  },
  methods: {
    viewStatementInvoice(public_id){
      this.$router.push(routeItems.customer_order_invoice_route+'/'+public_id)
    },
    tabSelectFn(index){
      const page = this.$route.query.page || ""
      const search = this.$route.query.keyword || ""
      this.$router.push({query: {keyword: search, page: page, tab: index}}).catch(() => {})
    },
    searchFn(data){
      this.shipmentSearchKeyword = data
    },
    searchOrderFn(data){
      this.orderSearchKeyword = data
    },
    refetchProduct(){
      this.$apollo.queries.product.refetch()
    },
  },
  watch: {
    shipmentCurrentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    ordersCurrentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  beforeMount() {
    this.tabIndex = this.$route.query.tab || "info"
  }
}
</script>

<style scoped>

</style>
